import Events from 'redux/events'

const initialState = {
    loading: true,
    bundles: [],
    soundboxs: [],
    soundboxsUrls: []
};

export default (state = initialState, action) => {
    switch(action.type) {
        /* BUNDLE */
        case Events.ADD_BUNDLE:
            return {
                ...state,
                bundles: action.bundles,
                soundboxs: [...action.soundboxs],
            };
        case Events.EDIT_BUNDLE:
            return {
                ...state,
                bundles: action.bundles,
                soundboxs: [...action.soundboxs],
                loading: false
            };
        case Events.SORT_BUNDLE:
            return {
                ...state,
                bundles: [...action.bundles]
            };
        case Events.DELETE_BUNDLE:
            return {
                ...state,
                bundles: action.bundles,
                soundboxs: [...action.soundboxs],
            };
        /* SOUDNBOX */
        case Events.ADD_SOUND:
            return {
                ...state,
                soundboxs: [...action.soundboxs],
            };
        case Events.EDIT_SOUND:
            return {
                ...state,
                soundboxs: [...action.soundboxs],
            };
        case Events.SORT_SOUND:
            return {
                ...state,
                soundboxs: [...action.soundboxs],
            };
        case Events.DELETE_SOUND:
            return {
                ...state,
                soundboxs: [...action.soundboxs],
            };
        /* CHARACTER */
        case Events.ADD_CHARACTER:
            return {
                ...state,
                soundboxs: [...action.soundboxs],
            };
        case Events.EDIT_CHARACTER:
            return {
                ...state,
                soundboxs: [...action.soundboxs],
            };
        case Events.DELETE_CHARACTER:
            return {
                ...state,
                soundboxs: [...action.soundboxs],
            };
        /* MOVIE */
        case Events.ADD_MOVIE:
            return {
                ...state,
                soundboxs: [...action.soundboxs],
            };
        case Events.EDIT_MOVIE:
            return {
                ...state,
                soundboxs: [...action.soundboxs]
            };
        case Events.DELETE_MOVIE:
            return {
                ...state,
                soundboxs: [...action.soundboxs],
            };
        /* SYNC */
        case Events.SYNC_BUNDLE:
            return {
                ...state,
                soundboxs: [...action.soundboxs],
                loading: false,
            };
        /* BLACK LIST */
        case Events.UPDATE_BLACK_LIST:
            return {
                ...state,
                soundboxs: [...action.soundboxs],
                loading: false,
            };
        /* LOAD */
        case Events.LOAD_INITIAL_DATA_SUCCESS:
            return {
                ...state,
                ...action.data,
                loading: false,
            };
        case Events.LOAD_DISTANT_DATA_SUCCESS:
            return {
                ...state,
                soundboxsUrls: [...state.soundboxsUrls, action.data],
            };
        case Events.LOADING:
            return {
                loading: true
            };
        case Events.LOADED:
            return {
                loading: false
            };
        default:
            return state;
    }
}